<template>
  <AuthGuard>
    <v-container>
      <v-row>
        <v-col></v-col>
        <v-col cols="12" sm="8" md="6" lg="5">
          <v-card>
            <v-card-title> {{ getFeedNameFromFeedType(feed!) }}</v-card-title>
            <v-card-text>
              <SourceConnectBirdEye
                v-if="feed === IApp.IFeedTypes.BirdEye"
                :customer-id="customerId!"
                :user-id="user?.id!"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col></v-col>
      </v-row>
    </v-container>
  </AuthGuard>
</template>

<script setup lang="ts">
import AuthGuard from "@/components/Auth/AuthGuard.vue";
import SourceConnectBirdEye from "@/components/SourceConnect/SourceConnectBirdEye.vue";
import useRouteParams from "@/hooks/useRouteParams";
import { useAuthStore } from "@/stores/auth";
import { IApp } from "@/types";
import { getFeedNameFromFeedType } from "@/utils";
import { computed } from "vue";

const authStore = useAuthStore();
const user = computed(() => authStore.user);

const { feed, customerId } = useRouteParams();
</script>
